export default __webpack_public_path__ + "static/media/40306.d3684076.jpg";